<template>
  <div class="animated fadeIn">
    <b-row class="justify-content-center">
      <b-col md="8" sm="12">
        <b-card no-body class="mx-6">
          <b-card-header>
            <h4>Override Claim Fields</h4>
          </b-card-header>
          <b-card-body class="p-6">
            <b-form @submit.stop.prevent="onSubmit">
              <b-row>
                <b-col sm="12">
                  <b-form-group>
                    <label for="name">Claim Id</label>
                    <b-form-input id="ClaimID"
                                  name="ClaimID"
                                  v-model="dataOverride.claim_id"
                                  type="text"
                                  v-validate="{required : true, min: 3, max:100 }"
                                  class="mb-1"
                                  placeholder="Enter a valid Claim Id."
                                  aria-describedby="claim-id-feedback"
                                  autocomplete="off" />

                    <div class="help-block alert alert-danger"
                         v-show="errors.has('ClaimID')">{{ errors.first('ClaimID') }}</div>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col sm="12">
                  <b-form-group>
                    <label for="name">Source</label>
                    <b-form-select v-model="dataOverride.source"
                                   :options="dataSources"
                                   class="mb-1"
                                   v-validate="{ required: true }"
                                   id="Source"
                                   name="Source">
                      <template slot="first">
                        <option :value="null" disabled>-- Please select an option --</option>
                      </template>
                    </b-form-select>

                    <div class="help-block alert alert-danger"
                         v-show="errors.has('Source')">{{ errors.first('Source') }}</div>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col sm="12">
                  <b-form-group>
                    <b-row class="mb-2">
                      <b-col sm="9">
                        <label for="name">Fields</label>
                      </b-col>
                    </b-row>
                    <b-form-select v-on:change="onChange"
                                   v-model="selectedFieldItem"
                                   class="mb-3">
                      <template slot="first">
                        <option :value="null" disabled>-- Please select an option --</option>
                      </template>
                      <option v-for="field in dataFields" v-bind:key="field.name" v-bind:value="field.name">{{field.name}}</option>
                    </b-form-select>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col sm="12">
                  <b-form-group>
                    <template v-for="field in dataFields">
                      <b-row v-bind:key="field.Key" class="mb-2" v-if="field.selected">
                        <b-col sm="4">
                          <label for="name">{{field.name}}</label>
                        </b-col>
                        <b-col sm="5">
                          <b-form-input :ref="'Key'" v-model="field.value" type="text" :minlength="field.minlength" :maxlength="field.maxlength" :placeholder="field.placeholder" />
                        </b-col>
                        <b-col sm="1">
                          <b-button-close class="x-button" aria-label="Close"
                                          v-on:click="onXClick(field.name)">
                            <span :id="field.Key" aria-hidden="true">&times;</span>
                          </b-button-close>
                        </b-col>
                      </b-row>
                    </template>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col cols="3" sm="3" offset-sm="9">
                  <b-button variant="primary"
                            block
                            v-on:click="onSubmit()"
                            :disabled="errors.any() || isBusy">
                    Submit
                    <i v-if="isBusy" class="fa fa-spinner fa-pulse button-spinner"></i>
                  </b-button>
                </b-col>
              </b-row>
            </b-form>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
    <b-row v-if="searchResults">
      <b-col lg="12">
        <b-card>
          <b-card-header>
            <b-row>
              <b-col>
                <h4>Records</h4>
              </b-col>
              <b-col>
                <div class="pull-right">
                  <h5>Total Records: {{searchResults.length}}</h5>
                </div>
              </b-col>
            </b-row>
          </b-card-header>
          <b-table striped
                   hover
                   :fields="claimfields"
                   :items="searchResults"
                   :per-page="size"
                   :current-page="currentPage"
                   small>
            <template slot="claimId" slot-scope="data">
              <b-button class="substatus-button"
                        :variant="'link'"
                        @click.stop="data.toggleDetails">{{data.item.claimId}}</b-button>
            </template>
            <template slot="source_name" slot-scope="data">
              {{ data.item.sourceName }}
            </template>
            <template slot="row-details" slot-scope="row">
              <b-card>
                <span v-if="Object.keys(row.item.dataFields).length > 0">
                  <DORowDetail v-bind:details="row.item.dataFields"></DORowDetail>
                </span>
                <span v-else>
                  <h6>Claim Submitted with original values.</h6>
                </span>
                <b-button :variant="'link'" class="float-right" @click.stop="row.toggleDetails">Hide</b-button>
              </b-card>
            </template>
          </b-table>
          <b-pagination
            align="center"
            :total-rows="rows"
             v-model="currentPage"
            :per-page="size"
          ></b-pagination>
        </b-card>
      </b-col>
    </b-row>
    <b-modal ref="success-field-modal" v-if="this.isSuccess()" v-model="showDismissibleAlert" hide-footer hide-header @hide="onSuccessModalCloseClick()">
      <div class="d-block">
        <b-alert v-model="showDismissibleAlert" variant="success">
          <p>Claims data override event completed successfully.</p>
          <p>Modified fields are:</p>
          <template v-for="field in modifiedFieldList">
            <b-row v-bind:key="field.name" class="mb-2">
              <b-col sm="6">
                <label for="name">{{field.name}}</label>
              </b-col>
              <b-col sm="6">
                <b>
                  <label class="success-label" for="name">{{field.value}}</label>
                </b>
              </b-col>
            </b-row>
          </template>
        </b-alert>
      </div>
      <b-button class="mt-3" block @click="onSuccessModalCloseClick()">OK</b-button>
    </b-modal>
    <b-modal ref="field-modal" v-model="modalShow" hide-footer>
      <div class="d-block text-center">
        <h3>Field already selected for modification.</h3>
      </div>
      <b-button class="mt-3" block @click="onModalCloseClick()">OK</b-button>
    </b-modal>
    <b-modal ref="empty-field-modal" v-model="emptyfieldmodalShow" hide-footer>
      <div class="d-block">
        <b-alert v-model="emptyfieldmodalShow" variant="danger">
          <p>Please provide required fields:</p>
          <template v-for="field in dataFields">
            <b-row v-bind:key="field.name" v-if="field.selected == true && field.value == ''" class="mb-2">
              <b-col sm="4">
                <label for="name">{{field.name}}</label>
              </b-col>
            </b-row>
          </template>
        </b-alert>
      </div>
      <b-button class="mt-3" block @click="onEmptyFieldModalCloseClick()">OK</b-button>
    </b-modal>
    <b-modal ref="errors-field-modal" v-model="errorsfieldmodalShow" hide-footer>
      <div class="d-block">
        <b-alert v-model="errorsfieldmodalShow" variant="danger">
          <p>Please fix following field errors:</p>
          <template v-for="field in dataFields">
            <b-row v-bind:key="field.name" v-if="field.selected && field.isInvalid" class="mb-2">
              <b-col sm="12">
                <label for="name">{{field.name}} - {{field.error}}</label>
              </b-col>
            </b-row>
          </template>
        </b-alert>
      </div>
      <b-button class="mt-3" block @click="onErrorsFieldModalCloseClick()">OK</b-button>
    </b-modal>
    <b-modal ref="zero-field-selected-modal" v-model="zerofieldselectedmodalShow" hide-footer>
      <div class="d-block">
        <b-alert v-model="zerofieldselectedmodalShow" variant="danger">
          <p>
            The claim is about to be submitted with the original claim values.
            Do you wish to continue?
          </p>
        </b-alert>
      </div>
      <b-button class="mt-3" block @click="onZeroFieldSelectedModalYesClick()">Yes</b-button>
      <b-button class="mt-3" block @click="onZeroFieldSelectedModalNoClick()">No</b-button>
    </b-modal>
  </div>
</template>

<script>
  import {
    PA_CREATE_DATAOVERRIDE,
    PA_CREATE_DATAOVERRIDE_CLEAR_MESSAGE,
    PA_SEARCH_DATAOVERRIDE
  } from "@/store/dataoverride/actions.type";

  import { mapState } from "vuex";
  import DORowDetail from "@/components/DORowDetail";
  export default {
    name: "DataOverride",
    components: {
      DORowDetail
    },
    data() {
      return {
        currentPage: 1,
        size: 20,
        dataFields: allDataFields,
        dataSources: allDataSources,
        modalShow: false,
        fields: [],
        selectedFieldItem: null,
        showDismissibleAlert: false,
        emptyfieldmodalShow: false,
        errorsfieldmodalShow: false,
        zerofieldselectedmodalShow: false,
        dataOverride: {
          claim_id: "",
          source: null,
          dataFields: {}
        },
        claimfields: [
          {
            key: "claimId",
            label: "Claim ID",
            sortable: true
          },
          {
            key: "sourceName",
            label: "Source",
            sortable: true
          },
          {
            key: "statusText",
            label: "Status",
            sortable: true
          }]
      };
    },
    computed: {
      ...mapState({
        isBusy: state => state.da.isBusy,
        message: state => state.da.message,
        searchResults: state => state.da.searchResults
      }),
      rows() {
        return this.searchResults.length;
      },
      modifiedFieldList() {
        return this.dataFields.filter(x => x.selected === true);
      },
      isAnySelectedFieldsHasEmptyData() {
        return (this.dataFields.filter(x => x.selected === true && x.value === '').length > 0);
      },
      isInvalidFieldExists() {
        /* eslint-disable */
        this.modifiedFieldList.forEach(element => {
          var regex = RegExp(element.pattern);
          if (!regex.test(element.value)) {
            element.isInvalid = true;
          }
          this.dataOverride.dataFields[element.name] = element.value;
        });
        return (this.dataFields.filter(x => x.isInvalid === true).length > 0);
        /* eslint-enable */
      }
    },
    methods: {
      isSuccess() {
        if (this.message === "Success") {
          this.showDismissibleAlert = true;
          return true;
        }
        this.showDismissibleAlert = false;
        return false;
      },
      onChange() {
        this.$store.dispatch(PA_CREATE_DATAOVERRIDE_CLEAR_MESSAGE);
        var item = this.dataFields.find(obj => obj.name === this.selectedFieldItem);
        if (item !== undefined && item.selected === false) {
          item.selected = true;
        } else {
          this.modalShow = true;
        }
      },
      onXClick(name) {
        this.$store.dispatch(PA_CREATE_DATAOVERRIDE_CLEAR_MESSAGE);
        var item = this.dataFields.find(obj => obj.name === name);
        if (item !== undefined) {
          item.selected = false;
          item.value = '';
        }
        this.selectedFieldItem = null;
      },
      onSubmit() {
        this.$validator.validateAll().then(result => {
          if (!result) {
            return;
          }

          // On Submit Click
          // if no field selected, show a modal for original value submission.
          // if a field is selected and not populated with any data, then give validation error
          // if a field is selected and has validation error, the show validation error
          if (this.modifiedFieldList.length === 0) {
            this.zerofieldselectedmodalShow = true;
            return;
          } else if (this.isAnySelectedFieldsHasEmptyData) {
            this.emptyfieldmodalShow = true;
            return;
          } else if (this.isInvalidFieldExists) {
            this.errorsfieldmodalShow = true;
            return;
          }

          if (!this.$store.state.isBusy) {
            this.$store.dispatch(PA_CREATE_DATAOVERRIDE, this.dataOverride);
          }
        });
      },
      onModalCloseClick() {
        this.$refs["field-modal"].hide();
        this.selectedFieldItem = null;
      },
      onEmptyFieldModalCloseClick() {
        this.$refs["empty-field-modal"].hide();
      },
      onZeroFieldSelectedModalNoClick() {
        this.$refs["zero-field-selected-modal"].hide();
      },
      onZeroFieldSelectedModalYesClick() {
        if (!this.$store.state.isBusy) {
          this.dataOverride.dataFields = {};
          this.$store.dispatch(PA_CREATE_DATAOVERRIDE, this.dataOverride);
          this.$refs["zero-field-selected-modal"].hide();
        }
      },
      onErrorsFieldModalCloseClick() {
        this.$refs["errors-field-modal"].hide();
        this.dataFields.forEach(function (element) {
          element.isInvalid = false;
        });
      },
      onSuccessModalCloseClick() {
        this.$refs["success-field-modal"].hide();
        this.clear();
      },
      clear() {
        this.dataFields.forEach(function (element) {
          element.selected = false;
          element.value = '';
          element.isInvalid = false;
        });
        this.dataOverride.claim_id = '';
        this.dataOverride.source = null;
        this.selectedFieldItem = null;
        this.$validator.reset();
        this.$store.dispatch(PA_CREATE_DATAOVERRIDE_CLEAR_MESSAGE);
        this.search();
      },
      search() {
        if (!this.$store.state.da.isSearchBusy) {
          this.$store.dispatch(PA_SEARCH_DATAOVERRIDE);
        }
      }
    },
    beforeMount() {
      this.$store.dispatch(PA_SEARCH_DATAOVERRIDE);
    }
  };

  const allDataSources = {
    horizon: "horizon",
    emdeon: "emdeon",
    argus: "argus"
  };
  /* eslint-disable */
  const addressLine1Regex = '^(?!P(ost|ostal)?([ \.]*O(ffice)?)?([ \.]*Box)?).*$';
  /* eslint-enable */
  const addressLine1ErrorMessage = 'PO Box address not allowed.';
  const allowedCharactersRegex = '^[ -~]+$';
  const allowedCharErrorMessage = 'Invalid Data. ' +
    'Please ensure that entered values adhere to the following:' +
    '* ASCII values 32-126 characters...' +
    '* Letters upper or lower case A-Z' +
    '* Numbers 0-9' +
    '* symbols restricted to: !"#$%&\'()*+^,-./:;<=>?@[]-{|}~';

  const allDataFields =
    [{ name: 'COBPrimaryRejectCode1', type: 'text', minlength: '1', maxlength: '100', value: '', selected: false, isInvalid: false, pattern: allowedCharactersRegex, error: allowedCharErrorMessage },
    { name: 'COBPrimaryRejectCode2', type: 'text', minlength: '1', maxlength: '100', value: '', selected: false, isInvalid: false, pattern: allowedCharactersRegex, error: allowedCharErrorMessage },
    { name: 'COBPrimaryRejectCode3', type: 'text', minlength: '1', maxlength: '100', value: '', selected: false, isInvalid: false, pattern: allowedCharactersRegex, error: allowedCharErrorMessage },
    { name: 'CopayPayerBIN', type: 'text', minlength: '1', maxlength: '100', value: '', selected: false, isInvalid: false, pattern: allowedCharactersRegex, error: allowedCharErrorMessage },
    { name: 'CopayPayerGroupID', type: 'text', minlength: '1', maxlength: '100', value: '', selected: false, isInvalid: false, pattern: allowedCharactersRegex, error: allowedCharErrorMessage },
    { name: 'CopayPayerMemberID', type: 'text', minlength: '1', maxlength: '100', value: '', selected: false, isInvalid: false, pattern: allowedCharactersRegex, error: allowedCharErrorMessage },
    { name: 'CopayPayerPCN', type: 'text', minlength: '1', maxlength: '100', value: '', selected: false, isInvalid: false, pattern: allowedCharactersRegex, error: allowedCharErrorMessage },
    { name: 'DateFilled', type: 'text', minlength: '10', maxlength: '10', pattern: '^(0[1-9]|1[0-2])\\/(0[1-9]|1\\d|2\\d|3[01])\\/(19|20)\\d{2}$', value: '', selected: false, placeholder: 'mm/dd/yyyy', isInvalid: false, error: 'Invalid Date. Valid Date Format (mm/dd/yyyy).' },
    { name: 'DateOfBirth', type: 'text', minlength: '10', maxlength: '10', pattern: '^(0[1-9]|1[0-2])\\/(0[1-9]|1\\d|2\\d|3[01])\\/(19|20)\\d{2}$', value: '', selected: false, placeholder: 'mm/dd/yyyy', isInvalid: false, error: 'Invalid Date. Valid Date Format (mm/dd/yyyy).' },
    { name: 'DateWritten', type: 'text', minlength: '10', maxlength: '10', pattern: '^(0[1-9]|1[0-2])\\/(0[1-9]|1\\d|2\\d|3[01])\\/(19|20)\\d{2}$', value: '', selected: false, placeholder: 'mm/dd/yyyy', isInvalid: false, error: 'Invalid Date. Valid Date Format (mm/dd/yyyy).' },
    { name: 'DAWCode', type: 'text', minlength: '1', maxlength: '1', value: '', selected: false, isInvalid: false, pattern: allowedCharactersRegex, error: allowedCharErrorMessage },
    { name: 'DaysSupply', type: 'text', minlength: '1', pattern: '^[0-9]+$', value: '', selected: false, placeholder: 'Any number. example: 1', isInvalid: false, error: 'Invalid Number.' },
    { name: 'DrugName', type: 'text', minlength: '1', maxlength: '105', value: '', selected: false, isInvalid: false, pattern: allowedCharactersRegex, error: allowedCharErrorMessage },
    { name: 'DrugNDCNumber', type: 'text', minlength: '1', maxlength: '11', value: '', selected: false, isInvalid: false, pattern: allowedCharactersRegex, error: allowedCharErrorMessage },
    { name: 'FillNumber', type: 'text', minlength: '1', pattern: '^[0-9]+$', value: '', selected: false, placeholder: 'Any number. example: 1', isInvalid: false, error: 'Invalid Number.' },
    { name: 'GenderCode', type: 'text', minlength: '1', maxlength: '1', value: '', pattern: '[MFU]', placeholder: 'Valid Gender Codes. (\'M\', \'F\' or \'U\'))', selected: false, isInvalid: false, error: 'Invalid Gender Code detected.' },
    { name: 'NewOrRefill', type: 'text', minlength: '1', maxlength: '100', value: '', selected: false, isInvalid: false, pattern: allowedCharactersRegex, error: allowedCharErrorMessage },
    { name: 'NumberOfRefillsAuthorized', type: 'text', minlength: '1', pattern: '^[0-9]+$', value: '', selected: false, placeholder: 'Any number. example: 1', isInvalid: false, error: 'Invalid Number.' },
    { name: 'OtherCoverageCode', type: 'text', minlength: '1', maxlength: '100', value: '', selected: false, isInvalid: false, pattern: allowedCharactersRegex, error: allowedCharErrorMessage },
    { name: 'PatientFirstName', type: 'text', minlength: '1', maxlength: '35', value: '', selected: false, isInvalid: false, pattern: allowedCharactersRegex, error: allowedCharErrorMessage },
    { name: 'PatientLastName', type: 'text', minlength: '1', maxlength: '35', value: '', selected: false, isInvalid: false, pattern: allowedCharactersRegex, error: allowedCharErrorMessage },
    { name: 'PatientOutOfPocket', type: 'text', minlength: '1', pattern: '^[0-9]+(\\.[0-9]{1,2})?$', value: '', selected: false, placeholder: 'Any number. example: 1.01', isInvalid: false, error: 'Invalid Number.' },
    { name: 'PharmacyAdd1', type: 'text', minlength: '1', maxlength: '35', value: '', pattern: addressLine1Regex, selected: false, isInvalid: false, error: addressLine1ErrorMessage },
    { name: 'PharmacyAdd2', type: 'text', minlength: '1', maxlength: '35', value: '', selected: false, isInvalid: false, pattern: allowedCharactersRegex, error: allowedCharErrorMessage },
    { name: 'PharmacyCity', type: 'text', minlength: '1', maxlength: '100', value: '', selected: false, isInvalid: false, pattern: allowedCharactersRegex, error: allowedCharErrorMessage },
    { name: 'PharmacyFax', type: 'text', minlength: '10', maxlength: '10', pattern: '^[0-9]+$', value: '', selected: false, placeholder: 'Any Fax number. example: 1234567890', isInvalid: false, error: 'Invalid Fax Number. Valid Fax Number length: (10) numeric characters.' },
    { name: 'PharmacyName', type: 'text', minlength: '1', maxlength: '100', value: '', selected: false, isInvalid: false, pattern: allowedCharactersRegex, error: allowedCharErrorMessage },
    { name: 'PharmacyNCPDPNumber', type: 'text', minlength: '1', maxlength: '100', value: '', selected: false, isInvalid: false, pattern: allowedCharactersRegex, error: allowedCharErrorMessage },
    { name: 'PharmacyNPI', type: 'text', minlength: '1', maxlength: '10', value: '', selected: false, placeholder: 'Any 10-digit identification number.', isInvalid: false, pattern: allowedCharactersRegex, error: allowedCharErrorMessage },
    { name: 'PharmacyPhone', type: 'text', minlength: '10', maxlength: '10', pattern: '^[0-9]+$', value: '', selected: false, placeholder: 'Any Phone number. example: 1234567890', isInvalid: false, error: 'Invalid Phone Number. Valid Phone Number length: (10) numeric characters.' },
    { name: 'PharmacyState', type: 'text', minlength: '2', maxlength: '2', value: '', selected: false, pattern: '^[A-Za-z]+$', placeholder: 'Any State code . example: NJ', isInvalid: false, error: 'Invalid state code detected.' },
    { name: 'PharmacyZip', type: 'text', minlength: '5', maxlength: '10', pattern: '^[0-9]+$', value: '', selected: false, isInvalid: false, error: 'Invalid Zip. Valid Zip length: (5-10) numeric characters.' },
    { name: 'PrescriberAdd1', type: 'text', minlength: '1', maxlength: '35', value: '', pattern: addressLine1Regex, selected: false, isInvalid: false, error: addressLine1ErrorMessage },
    { name: 'PrescriberAdd2', type: 'text', minlength: '1', maxlength: '35', value: '', selected: false, isInvalid: false, pattern: allowedCharactersRegex, error: allowedCharErrorMessage },
    { name: 'PrescriberCity', type: 'text', minlength: '1', maxlength: '100', value: '', selected: false, isInvalid: false, pattern: allowedCharactersRegex, error: allowedCharErrorMessage },
    { name: 'PrescriberDEA', type: 'text', minlength: '1', maxlength: '100', value: '', selected: false, isInvalid: false, pattern: allowedCharactersRegex, error: allowedCharErrorMessage },
    { name: 'PrescriberFN', type: 'text', minlength: '1', maxlength: '100', value: '', selected: false, isInvalid: false, pattern: allowedCharactersRegex, error: allowedCharErrorMessage },
    { name: 'PrescriberLN', type: 'text', minlength: '1', maxlength: '100', value: '', selected: false, isInvalid: false, pattern: allowedCharactersRegex, error: allowedCharErrorMessage },
    { name: 'PrescriberNPI', type: 'text', minlength: '1', maxlength: '10', value: '', selected: false, placeholder: 'Any 10-digit identification number.', isInvalid: false, pattern: allowedCharactersRegex, error: allowedCharErrorMessage },
    { name: 'PrescriberPhone', type: 'text', minlength: '10', maxlength: '10', pattern: '^[0-9]+$', value: '', selected: false, placeholder: 'Any Phone number. example: 1234567890', isInvalid: false, error: 'Invalid Phone Number. Valid Phone Number length: (10) numeric characters.' },
    { name: 'PrescriberState', type: 'text', minlength: '2', maxlength: '2', value: '', pattern: '^[A-Za-z]+$', selected: false, placeholder: 'Any State code . example: NJ', isInvalid: false, error: 'Invalid state code detected.' },
    { name: 'PrescriberZip', type: 'text', minlength: '5', maxlength: '10', value: '', pattern: '^[0-9]+$', selected: false, isInvalid: false, error: 'Invalid Zip. Valid Zip length: (5-10) numeric characters.' },
    { name: 'PrimaryPayerBIN', type: 'text', minlength: '1', maxlength: '100', value: '', selected: false, isInvalid: false, pattern: allowedCharactersRegex, error: allowedCharErrorMessage },
    { name: 'PrimaryPayerGroupID', type: 'text', minlength: '1', maxlength: '100', value: '', selected: false, isInvalid: false, pattern: allowedCharactersRegex, error: allowedCharErrorMessage },
    { name: 'PrimaryPayerGroupName', type: 'text', minlength: '1', maxlength: '100', value: '', selected: false, isInvalid: false, pattern: allowedCharactersRegex, error: allowedCharErrorMessage },
    { name: 'PrimaryPayerPBMName', type: 'text', minlength: '1', maxlength: '100', value: '', selected: false, isInvalid: false, pattern: allowedCharactersRegex, error: allowedCharErrorMessage },
    { name: 'PrimaryPayerPCN', type: 'text', minlength: '1', maxlength: '100', value: '', selected: false, isInvalid: false, pattern: allowedCharactersRegex, error: allowedCharErrorMessage },
    { name: 'PrimaryPayerPlanID', type: 'text', minlength: '1', maxlength: '100', value: '', selected: false, isInvalid: false, pattern: allowedCharactersRegex, error: allowedCharErrorMessage },
    { name: 'PrimaryPayerPlanName', type: 'text', minlength: '1', maxlength: '100', value: '', selected: false, isInvalid: false, pattern: allowedCharactersRegex, error: allowedCharErrorMessage },
    { name: 'PTAddressLine1', type: 'text', minlength: '1', maxlength: '35', value: '', pattern: addressLine1Regex, selected: false, isInvalid: false, error: addressLine1ErrorMessage },
    { name: 'PTAddressLine2', type: 'text', minlength: '1', maxlength: '35', value: '', selected: false, isInvalid: false, pattern: allowedCharactersRegex, error: allowedCharErrorMessage },
    { name: 'PTCity', type: 'text', minlength: '1', maxlength: '100', value: '', selected: false, isInvalid: false, pattern: allowedCharactersRegex, error: allowedCharErrorMessage },
    { name: 'PTState', type: 'text', minlength: '2', maxlength: '2', value: '', selected: false, pattern: '^[A-Za-z]+$', placeholder: 'Any State code . example: NJ', isInvalid: false, error: 'Invalid state code detected.' },
    { name: 'PTZipCode', type: 'text', minlength: '5', maxlength: '10', value: '', pattern: '^[0-9]+$', selected: false, isInvalid: false, error: 'Invalid Zip. Valid Zip length: (5-10) numeric characters.' },
    { name: 'QuantityDispensed', type: 'text', minlength: '1', pattern: '^[0-9]+(\\.[0-9]{1,2})?$', value: '', selected: false, placeholder: 'Any number. example: 1.01', isInvalid: false, error: 'Invalid Number.' }
    ];
</script>

<style>
  .x-button {
    color: red;
    font-size: 25px;
  }

  .success-label {
    word-break: break-all;
  }

  .mt-10 {
    margin-top: 10px !important;
  }
</style>



// WEBPACK FOOTER //
// src/views/DataOverride.vue